import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

import { PanelHeaderSummary, PanelHeaderSummaryInfo } from "../../../Layout/Panel";
import { formatQuantityValue } from "../../../../helpers/unitOfMeasurementHelpers";
import Button from "./../../../Common/Button";

export default class OrderPanelHeaderSummaryMobile extends PureComponent {
  static propTypes = {
    isSummaryOpen: PropTypes.bool,
    purchaseOrder: PropTypes.object,
    summaryButtonClick: PropTypes.func
  };

  static defaultProps = {
    isSummaryOpen: false,
    purchaseOrder: {},
    summaryButtonClick: null
  };

  render() {
    const { isSummaryOpen, purchaseOrder, summaryButtonClick } = this.props;
    const { soldTo = {}, shipTo = {}, quantityAcknowledged = {}, quantityShipped = {}, quantityRemaining = {} } = purchaseOrder;

    return (
      <PanelHeaderSummary isSummaryOpen={isSummaryOpen}>
        <div className="panel-summary__section-row-container">
          <div className="panel-summary__section-row">
            <PanelHeaderSummaryInfo label={i18n.t("purchaseOrder.soldTo")} value={soldTo.customerName} className="--flex-2" />
          </div>
          <div className="panel-summary__section-row">
            <PanelHeaderSummaryInfo label={i18n.t("purchaseOrder.shipTo")} value={shipTo.customerName} className="--flex-2" />
          </div>
          <div className="panel-summary__section-row">
            <PanelHeaderSummaryInfo label={i18n.t("purchaseOrder.poPeriod")} value={purchaseOrder.pricingPeriodDate} className="--flex-2" />
            <PanelHeaderSummaryInfo label={i18n.t("purchaseOrder.endUser")} value={purchaseOrder.endUserId} className="--flex-2" />
          </div>
          <div className="panel-summary__section-row">
            <PanelHeaderSummaryInfo label={i18n.t("purchaseOrder.ordered")} value={formatQuantityValue(quantityAcknowledged)} />
            <PanelHeaderSummaryInfo label={i18n.t("purchaseOrder.shipped")} value={formatQuantityValue(quantityShipped)} />
            <PanelHeaderSummaryInfo label={i18n.t("purchaseOrder.remaining")} value={formatQuantityValue(quantityRemaining)} />
          </div>
        </div>

        <Button className="panel-summary__close-button" icon="arrow-up-flat" onClick={summaryButtonClick} />
      </PanelHeaderSummary>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/Panel/HeaderSummaryMobile.js